import { withFormik } from 'formik';
import { withStore } from 'store';
import UploadImageModal from './UploadImageModal';

const mapPropsToValues = ({ tableInfo = {}, showTableInfoData, ...props }) => {
  const { image = '' } = showTableInfoData ? tableInfo : props;

  return {
    selectedImage: { image },
  };
};

export default withStore({
  mapStateToProps: (state) => ({
    listOfImageGallery: state.catalogs.listOfImageGallery,
    tableInfo: state.giftTable.giftTableInfo.data,
  }),
})(withFormik({ mapPropsToValues })(UploadImageModal));
